<template>
  <account-modal class="profile-customer-account-number-form-modal">
    <template slot="heading">
      <div>Add new IBAN to &quot;{{ customer.name }}&quot;&nbsp;({{ customer.id }})</div>
    </template>

    <template slot="content">
      <v-select
        id="account-number-channel"
        v-model="channel"
        :items="channelOptions"
        item-text="name"
        item-value="value"
        label="Channel"
        hint="Required field"
        persistent-hint
        :error-messages="getValidationErrorMessage('channel')"
      />

      <error-alert :error="error" />
    </template>

    <template slot="actions">
      <v-btn
        color="light-blue darken-3"
        flat
        :disabled="loading"
        @click="onUseButtonClick"
      >yes</v-btn>

      <v-btn
        color="light-blue darken-3"
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </account-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_PROFILE_CUSTOMER_UPDATE } from '@/events/profileCustomers'

  // Mixins
  import form from '@/mixins/form'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import ProfileCustomerApi from '@/services/Api/ProfileCustomerApi'

  // Component
  import AccountModal from '@/components/accounts/AccountModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'ProfileCustomerAccountNumberFormModal',
    components: {
      AccountModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        channel: null,
        profileCustomerAddAccountNumber: new ApiRequest(ProfileCustomerApi.addAccountNumber)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      customer () {
        return this.modal.data.customer
      },
      walletId () {
        return this.modal.data.walletId
      },
      channelOptions () {
        return this.modal.data.channelOptions
      },
      loading () {
        return this.profileCustomerAddAccountNumber.loading
      },
      error () {
        return this.profileCustomerAddAccountNumber.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onUseButtonClick () {
        this.profileCustomerAddAccountNumber
          .execute(
            this.customer.id,
            {
              walletId: this.walletId,
              channel: this.channel
            }
          )
          .then(this.successHandler)
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      successHandler () {
        this.$eventHub.$emit(EVENT_PROFILE_CUSTOMER_UPDATE)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Account Number has been successfully added.' }
          })
        }, 100)
      }
    }
  }
</script>
